module.exports = __webpack_public_path__ + "assets/SquareInSquareDetailed.62b94c4d4126a471bf693fb53a5194bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareInSquareDetailed.png
// module id = 569
// module chunks = 0